import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import Modal from "../../../app/components/modals/Modal";
import useStyles from "./styles";
import { translate as t } from "../../translate/localization";
import CobeeButton from "../../../app/components/CobeeButton";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import renderApproveRentingModal from "../ApproveRentingModal/render-approve-renting-modal";

export default function RentingResultsModal({
  isLoading,
  previousCallback,
  callback,
  firstPaymentTimestamp,
  lastPaymentTimestamp,
  firstPaymentAmount,
  amountPerPayment,
  numberOfPayments,
  totalAmount,
  monthlyAttribution,
  payload,
}) {
  const { container, buttonRow, divider, row } = useStyles();

  const prettifyMoney = (value) =>
    value && MonetaryAmount.ofCurrency(value).prettifyMoney({});

  return (
    <Modal title={t("actions.approve-request")}>
      <Grid item container xs={12} className={container}>
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            {t("common-messages.first-quota-date")}:
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">
            {moment(new Date(firstPaymentTimestamp * 1000)).format(
              "DD/MM/YYYY"
            )}
          </Typography>
        </Grid>
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            {t("common-messages.first-quota-amount")}:
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">
            {prettifyMoney(firstPaymentAmount)} (
            {t("common-messages.tax-included")})
          </Typography>
        </Grid>
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            {t("common-messages.remaining-quota-amount")}:
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">
            {prettifyMoney(amountPerPayment)} / {t("common-messages.month")} (
            {t("common-messages.tax-included")})
          </Typography>
        </Grid>
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            {t("common-messages.amount-to-extract-from-payroll")}: (
            {t("request-section.taxes-will-apply-message")})
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">
            {prettifyMoney(monthlyAttribution)} / {t("common-messages.month")}
          </Typography>
        </Grid>
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            {t("common-messages.number-of-quotas")}:
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">{numberOfPayments}</Typography>
        </Grid>
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            {t("common-messages.last-quote-date")}:
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">
            {" "}
            {moment(new Date(lastPaymentTimestamp * 1000)).format("DD/MM/YYYY")}
          </Typography>
        </Grid>
        <Grid item xs={12} className={divider} />
        <Grid item xs={5} className={row}>
          <Typography variant="body2">
            <b>{t("request-section.renting-total-amount")}:</b>
          </Typography>
        </Grid>
        <Grid item xs={7} className={row}>
          <Typography variant="body2">
            <b>
              {prettifyMoney(totalAmount)} (
              {t("common-messages.includes-first-quota")})
            </b>
          </Typography>
        </Grid>
        <Grid
          item
          container
          xs={12}
          justify="center"
          alignItems="center"
          className={buttonRow}
        >
          <CobeeButton
            styleType="secondary"
            onClick={() =>
              renderApproveRentingModal({
                defaultValues: payload,
                callback: previousCallback,
              })
            }
          >
            {t("actions.go-back")}
          </CobeeButton>
          <CobeeButton
            styleType="primary"
            onClick={callback}
            isLoading={isLoading}
          >
            {t("actions.approve-request")}
          </CobeeButton>
        </Grid>
      </Grid>
    </Modal>
  );
}

RentingResultsModal.defaultProps = { isLoading: false };

RentingResultsModal.propTypes = {
  isLoading: PropTypes.bool,
  previousCallback: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  firstPaymentTimestamp: PropTypes.number.isRequired,
  lastPaymentTimestamp: PropTypes.number.isRequired,
  firstPaymentAmount: PropTypes.object.isRequired,
  amountPerPayment: PropTypes.object.isRequired,
  numberOfPayments: PropTypes.number.isRequired,
  totalAmount: PropTypes.object.isRequired,
  monthlyAttribution: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
};
